export default "__VITE_ASSET__26154c7a__"